import ExitButton from "Components/Atoms/ExitButton";
import { motion } from "framer-motion";

/*
  @function HoverPage
  render an hover page that covers current page and shows content, it can be closed
  by clicking on button
  @params children {React.Node} - content to fill the page
  @params onClose {function} - function called on close
  @params direction {string} - diredction of animation
  @params halfPage {boolean} - says if page should be half or full page
  @returns {React.Node} 
*/
export default function HoverPage({
  children,
  onClose,
  direction = "left",
  halfPage = false,
}: {
  children: React.ReactNode;
  onClose: () => void;
  direction?: string;
  halfPage?: boolean;
}) {
  const position = halfPage ? (direction === "right" ? "56" : "0") : "0";

  return (
    <motion.div
      className={`absolute bg-white border-l h-full pt-28 z-30 ${
        halfPage ? "w-[44%]" : "w-full"
      }`}
      initial={direction === "left" ? { x: "-100vw" } : { x: "100vw" }}
      animate={{ x: `${position}vw` }}
      transition={{ type: "spring", damping: 30 }}
    >
      <div className="relative">
        <div className="absolute top-4 lg:-top-4 right-10 mx-4 ">
          <ExitButton onClick={onClose} />
        </div>
      </div>
      <div className="m-6">{children}</div>
    </motion.div>
  );
}
